<template>
    <v-dialog v-model="dialog" persistent max-width="500">
        <v-card justify="center">
             <v-card-title class="headline"></v-card-title>
            <v-card-text justify="center">
                         <v-img
                    :src="`${src}`"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    justify="center"
                    ></v-img>
            </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="disagre()">Ok</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data() {
        return {
        
        }
    },
    props:{
        dialog: Boolean,
        src: String
    },
    methods: {
        disagre(){
            this.$emit('showDialog')
        }
    },
}
</script>